import { render } from "./PatchingPanel.vue?vue&type=template&id=81131fa4&scoped=true"
import script from "./PatchingPanel.vue?vue&type=script&lang=js"
export * from "./PatchingPanel.vue?vue&type=script&lang=js"

import "./PatchingPanel.vue?vue&type=style&index=0&id=81131fa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81131fa4"]])

export default __exports__